import { render, staticRenderFns } from "./qusetBottom.vue?vue&type=template&id=1c5099e0&scoped=true&"
import script from "./qusetBottom.vue?vue&type=script&lang=js&"
export * from "./qusetBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5099e0",
  null
  
)

export default component.exports